/**
 * Centralized API Configuration
 * Ensures backend URL is always available, even on page reload
 */

// Get backend URL from environment variable with fallback
const getBackendURL = () => {
  // In development, ALWAYS use empty string to leverage Vite proxy
  // This avoids CORS issues by going through the proxy
  if (import.meta.env.DEV || import.meta.env.MODE === 'development') {
    return '';
  }

  // In production, use environment variable or fallback
  const envUrl = import.meta.env.VITE_BACKEND_URL;
  if (envUrl) {
    return envUrl;
  }

  // Production fallback (should be overridden by env var)
  return 'http://localhost:8000';
};

// export const BACKEND_URL = getBackendURL();
export const BACKEND_URL = 'https://api.board2boston.com';


// Build API URL - if BACKEND_URL is empty, use relative path for proxy
export const API = BACKEND_URL ? `${BACKEND_URL}/api` : '/api';

// Helper function to get full API URL
export const getApiUrl = (endpoint) => {
  // Remove leading slash if present to avoid double slashes
  const cleanEndpoint = endpoint.startsWith('/') ? endpoint.slice(1) : endpoint;
  return `${API}/${cleanEndpoint}`;
};

// WebSocket URL helper
export const getWebSocketUrl = (path) => {
  const wsProtocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:';

  // If BACKEND_URL is set, use it; otherwise use current origin
  let backendUrl = BACKEND_URL;
  if (!backendUrl) {
    // In development with proxy, use current origin
    backendUrl = window.location.origin;
  }

  const wsHost = backendUrl.replace(/^https?:\/\//, '').replace(/\/api$/, '');
  return `${wsProtocol}//${wsHost}${path}`;
};

// Log configuration for debugging (only in development)
if (import.meta.env.DEV) {
  console.log('API Configuration:', {
    BACKEND_URL: BACKEND_URL || 'http://localhost:8000',
    API,
    MODE: import.meta.env.MODE
  });
}

